import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify'; //react toast 
import { API_SERVER, initializeFilterData } from '../../Utils'; //common Data
import { getCommonData, getMasterData } from '../../apiservices/CommonServices';
import { post } from '../../apiservices/service'; //services
import { useAuth } from '../../context/auth';
import { Token, dateFormate } from '../Common/Common';
import { AutoCompleteBox, DateBox, FormButton, SelectInputBox } from "../commoncomponents/InputBox";
import { Table } from '../commoncomponents/Table';

function CompOffLeaveApplication() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();

    //token Data
    const TokenData = Token()
    //initial state
    const [recipe, setRecipe] = useState({
        Employee: '',
        CompOffDate: '',
        LeaveDate: '',
        Reason: ''
    })
    const [EmployeeData, setEmployeeData] = useState([])
    const [loading, setLoading] = useState(false)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [isUpdate, setIsUpdate] = useState(false)
    const [errors, setErrors] = useState({});
    const [tableData, setTableData] = useState({});


    ////handle Get Leave Register Table Data 
    //const GetLeaveRegisterTableData = (emp) => {
    //    post(`${API_SERVER}api/Leave/ShowLeaveRegister`, { ...TokenData, Employee: emp ? emp : '' }, (res) => {
    //        if (res && res.Status) {
    //            if (res.Status === "ERROR") {
    //                setLoading(false)
    //                setTableData({ ...res })
    //            } else if (res.Status === "EXPIRED") {
    //                sessionExpired()
    //                setLoading(false)
    //            } else {
    //                setLoading(false)
    //                setTableData({ ...res })
    //            }
    //        }
    //    });

    //}

    const getEmployeeData = () => {
        let temp = {
            Type: "GetEmployee",
            Prefix: '',
            ContextKey: "",
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setEmployeeData(data)
                }
            }
        });
    }


    useEffect(() => {
        inputrefs.current['txtEmployee'].focus();
        document.title = 'Viva HRMS : Comp Off Leave Application'
        getEmployeeData();
    }, [sortConfig])

    useEffect(() => {
    }, [isUpdate])

    let EmpData = []
    for (let i = 0; i < EmployeeData.length; i++) {
        let mydata = EmployeeData[i]?.values
        EmpData.push(mydata)
    };

    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "Employee", msg: 'Please Select Employee.!' },
            { field: "CompOffDate", msg: 'Please Select Comp Off Date.' },
            { field: "LeaveDate", msg: 'Please Select Leave To Date.' },
            { field: "Reason", msg: 'Please Enter Reason for Leave.' },
        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '' || recipe[item.field] === '0') {

                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        return isValid;
    }

    //handleSubmit Handler
    const handleSubmit = () => {
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/Leave/CompOffLeaveApplication`, { ...TokenData, ...recipe }, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message)
                        setLoading(false)
                    } else if (res.status === "EXPIRED") {
                        toast.error(res.message)
                        sessionExpired()
                    } else if (res.status === "UNAUTHORIZED") {
                        toast.error(res.message);
                        handleClear();
                        setLoading(false);
                    } else {
                        setLoading(false)
                        toast.success(res.message)
                        handleClear()
                    }
                }
            });
        }
    }

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe,
            Employee: '',
            CompOffDate: '',
            LeaveDate: '',
            Reason: ''
        }));
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        setTableData({})
        inputrefs.current['txtEmployee'].focus();
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> Comp Off Leave Application</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-12'>

                            <div className='row'>
                                <AutoCompleteBox
                                    divclassname='col-md-3 mb-1'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtCompOffDate'].focus() };
                                    }}
                                    label='Employee'
                                    placeholder="Employee"
                                    maxLength='100'
                                    options={EmpData}
                                    id='txtEmployee'
                                    required={true}
                                    error={errors.Employee}
                                    inputValue={recipe.Employee ? recipe.Employee : ''}
                                    onInputChange={(event, newInputValue) => {
                                        HandleChange('Employee', newInputValue)
                                    }}
                                />
                                <div className="col-md-3 mb-1">
                                    <div className="row">
                                        <DateBox
                                            divclassname="col-12"
                                            inputrefs={inputrefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['txtLeaveDate'].focus() };
                                            }}
                                            maxDate={recipe.ApplicationType === "Absent" && new Date()}
                                            minDate={recipe.ApplicationType === "Planned" && new Date()}
                                            label='Comp Off Date'
                                            id='txtCompOffDate'
                                            selected={recipe.CompOffDate === '' ? '' : new Date(recipe.CompOffDate)}
                                            maxLength='12'
                                            placeholder="Leave From"
                                            value={recipe.CompOffDate}
                                            onChange={(e) => {
                                                HandleChange('CompOffDate', dateFormate(e));
                                                if (e) setRecipe({ ...recipe, CompOffDate: dateFormate(e), LeaveDate: '' });
                                            }}
                                            required
                                            error={errors.CompOffDate}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-3 mb-1">
                                    <div className="row">
                                        <DateBox
                                            divclassname="col-12"
                                            inputrefs={inputrefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['txtReason'].focus() };
                                            }}
                                            minDate={new Date(recipe.CompOffDate)}
                                            maxDate={recipe.ApplicationType === "Absent" && new Date()}
                                            label='Leave To'
                                            id='txtLeaveDate'
                                            selected={recipe.LeaveDate === '' ? '' : new Date(recipe.LeaveDate)}
                                            maxLength='12'
                                            placeholder="Leave To"
                                            value={recipe.LeaveDate}
                                            error={errors.LeaveDate}
                                            onChange={(e) => HandleChange('LeaveDate', dateFormate(e))}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={`col-md-3 mb-1`} >
                                    <label> Reason <span style={{ color: "red" }}> *</span>
                                        <textarea
                                            ref={ref => (inputrefs.current['txtReason'] = ref)}
                                            className="form-control mt-1"
                                            id="txtReason"
                                            name="txtReason"
                                            rows={2} cols={100}
                                            placeholder="Enter Reason..."
                                            value={recipe.Reason}
                                            onChange={(e) => HandleChange('Reason', e.target.value)}
                                        /></label>
                                    <div className="error-msg">{errors.Reason}</div>
                                </div>

                                <FormButton
                                    Export={false}
                                    SaveText='Apply'
                                    saveButtonIcon='fa-check'
                                    handleSubmit={handleSubmit}
                                    handleClear={handleClear}
                                />

                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default CompOffLeaveApplication